import React, { useEffect, useMemo, useRef, useState } from "react";
import axios from "axios";
import styled from "styled-components";
//import QRCode from "react-qr-code";
import { QRCodeCanvas } from "qrcode.react";
import { Helmet } from "react-helmet";
const DEFAULT_AVATAR = "/images/default-avatar.png";

const Page = styled.div`
  min-height: 100vh;
  padding: 22px 18px 34px;
  background: linear-gradient(135deg, #232d3d 0%, #2c374a 50%, #1b2230 100%);
  color: #e5e7eb;
  font-family: Arial, sans-serif;
  direction: ${({ rtl }) => (rtl ? "rtl" : "ltr")};
  text-align: ${({ rtl }) => (rtl ? "right" : "left")};
`;

const HeroQR = styled.div`
  width: 126px;
  box-sizing: border-box;

  background: #ffffff;
  padding: 8px;
  border-radius: 12px;

  display: flex;
  flex-direction: column;
  align-items: center;

  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.35);
`;

const HeroQRBlock = styled.div`
  position: absolute;
  right: 24px;
  bottom: 16px;

  width: 126px;

  display: flex;
  flex-direction: column;
  align-items: center;
`;

const QRText = styled.div`
  margin-top: 6px;
  font-size: 10px;
  font-weight: 700;
  color: #111827;
  text-align: center;
`;

const PoweredBy = styled.div`
  margin-top: 7px;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;

  direction: ltr;
  white-space: nowrap;

  /*
   * No background—the hero image remains visible.
   */
  background: transparent;

  filter: drop-shadow(0 1px 3px rgba(0, 0, 0, 0.9));
`;

const PoweredByText = styled.span`
  color: rgba(255, 255, 255, 0.92);
  font-size: 9px;
  font-weight: 700;
`;

const PoweredByLogo = styled.img`
  width: 52px;
  height: auto;
  object-fit: contain;
`;

const Card = styled.div`
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  padding: 22px;
  border-radius: 28px;
  background: rgba(0, 0, 0, 0.48);
  border: 1px solid rgba(255, 255, 255, 0.12);
`;

const TopRightButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const Logo = styled.img`
  width: 95px;
  height: auto;
  margin-left: 0;
  opacity: 0.9;
`;

const CircleLogoContainer = styled.div`
  width: 150px;
  height: 82px;
  box-sizing: border-box;
  padding: 4px 6px;

  display: flex;
  align-items: center;
  justify-content: center;

  background: #000000;
  border: none;
  border-radius: 10px;
  overflow: hidden;

  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);
`;

const CircleLogo = styled.img`
  width: 100%;
  height: 100%;
  display: block;
  object-fit: contain;
  object-position: center;
  background: #000000;
`;

const Tabs = styled.div`
  display: flex;
  gap: 6px;
  margin: 14px 0 8px;
  flex-wrap: wrap;
`;

const Tab = styled.button`
  border: 1px solid
    ${({ active }) =>
      active ? "rgba(56, 189, 248, 0.55)" : "rgba(255, 255, 255, 0.08)"};

  border-radius: 999px;
  padding: 7px 13px;

  cursor: pointer;
  font-size: 15px;
  line-height: 1;
  font-weight: 650;

  color: ${({ active }) => (active ? "#ffffff" : "#b9c1cc")};

  background: ${({ active }) =>
    active ? "rgba(71, 85, 105, 0.72)" : "rgba(255, 255, 255, 0.055)"};

  box-shadow: ${({ active }) =>
    active ? "inset 0 0 0 1px rgba(56, 189, 248, 0.08)" : "none"};

  transition:
    background 0.2s ease,
    border-color 0.2s ease,
    color 0.2s ease,
    transform 0.2s ease;

  &:hover {
    transform: translateY(-1px);
    background: ${({ active }) =>
      active ? "rgba(71, 85, 105, 0.9)" : "rgba(255, 255, 255, 0.09)"};
  }

  @media (max-width: 560px) {
    padding: 7px 11px;
    font-size: 14px;
  }
`;

const JoinToast = styled.div`
  position: fixed;
  left: 50%;
  bottom: 26px;
  transform: translateX(-50%);
  z-index: 99999;

  display: flex;
  align-items: center;
  gap: 12px;

  min-width: 280px;
  max-width: calc(100% - 32px);
  padding: 14px 18px;
  border-radius: 999px;

  background: rgba(15, 23, 42, 0.96);
  border: 1px solid rgba(56, 189, 248, 0.45);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.45);

  color: white;
  animation: joinToastIn 0.35s ease-out;

  @keyframes joinToastIn {
    from {
      opacity: 0;
      transform: translateX(-50%) translateY(30px) scale(0.96);
    }
    to {
      opacity: 1;
      transform: translateX(-50%) translateY(0) scale(1);
    }
  }
`;

const JoinToastAvatar = styled.img`
  width: 42px;
  height: 42px;
  border-radius: 999px;
  object-fit: cover;
  background: #111827;
`;

const JoinToastFallback = styled.div`
  width: 42px;
  height: 42px;
  border-radius: 999px;
  background: #38bdf8;
  color: #020617;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 900;
`;

const JoinToastText = styled.div`
  display: flex;
  flex-direction: column;
`;

const JoinToastTitle = styled.div`
  font-weight: 900;
  font-size: 15px;
`;

const JoinToastSub = styled.div`
  color: #94a3b8;
  font-size: 13px;
  margin-top: 2px;
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: 46px 68px 1fr auto;
  gap: 12px;
  align-items: center;
  padding: 14px 10px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;

  opacity: 0;
  animation: rowEnter 0.5s ease-out forwards;
  animation-delay: ${({ index = 0 }) => `${Math.min(index, 12) * 70}ms`};

  transition:
    transform 0.35s ease,
    background 0.35s ease,
    box-shadow 0.35s ease;

  ${({ leader }) =>
    leader &&
    `
      background: linear-gradient(
        90deg,
        rgba(56, 189, 248, 0.14),
        rgba(56, 189, 248, 0.03)
      );
      box-shadow: inset 3px 0 0 #38bdf8;
    `}

  ${({ updated }) =>
    updated &&
    `
      animation:
        rowEnter 0.5s ease-out forwards,
        activityPulse 4s ease-out;

      background: rgba(34, 197, 94, 0.12);
      box-shadow:
        inset 4px 0 0 #22c55e,
        0 0 24px rgba(34, 197, 94, 0.18);
    `}

  @keyframes activityPulse {
    0% {
      background: rgba(34, 197, 94, 0.04);
    }

    20% {
      background: rgba(34, 197, 94, 0.22);
    }

    100% {
      background: rgba(34, 197, 94, 0);
    }
  }

  @keyframes rowEnter {
    from {
      opacity: 0;
      transform: translateY(14px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (max-width: 560px) {
    grid-template-columns: 38px 64px 1fr;
  }

  @media (prefers-reduced-motion: reduce) {
    opacity: 1;
    animation: none;
    transition: none;
  }
`;

const Rank = styled.div`
  font-weight: 900;
  color: #fff;
  font-size: 16px;
`;

const Avatar = styled.img`
  width: 64px;
  height: 64px;
  border-radius: 999px;
  object-fit: cover;
  background: #111827;
`;

const AvatarFallback = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 999px;
  background: #111827;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 900;
  font-size: 22px;
`;

const Name = styled.div`
  color: #fff;
  font-weight: 800;
`;

const Meta = styled.div`
  color: #94a3b8;
  font-size: 13px;
  margin-top: 3px;
`;

const Score = styled.div`
  color: #38bdf8;
  font-weight: 900;
  white-space: nowrap;
  animation: scorePop 0.45s ease-out;

  @keyframes scorePop {
    0% {
      opacity: 0;
      transform: scale(0.88);
    }

    70% {
      transform: scale(1.06);
    }

    100% {
      opacity: 1;
      transform: scale(1);
    }
  }

  @media (max-width: 560px) {
    grid-column: 3;
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

const LiveIndicator = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`;

const LiveDot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #22c55e;
  box-shadow: 0 0 0 rgba(34, 197, 94, 0.5);
  animation: livePulse 1.8s infinite;

  @keyframes livePulse {
    0% {
      box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.55);
    }

    70% {
      box-shadow: 0 0 0 8px rgba(34, 197, 94, 0);
    }

    100% {
      box-shadow: 0 0 0 0 rgba(34, 197, 94, 0);
    }
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

const Empty = styled.div`
  padding: 30px 0;
  text-align: center;
  color: #94a3b8;
`;

const Copyright = styled.div`
  width: 100%;
  max-width: 880px;
  margin: 14px auto 0;
  text-align: center;
  color: rgba(229, 231, 235, 0.65);
  font-size: 12px;
`;

const TabsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: -2px 0 6px;
  flex-wrap: wrap;
`;

const Switch = styled.input`
  width: 15px;
  height: 15px;
  cursor: pointer;
`;

const SettingsButton = styled.button`
  border: none;
  width: 38px;
  height: 38px;
  border-radius: 999px;
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;

  background: rgba(255, 255, 255, 0.1);
  color: #e5e7eb;

  font-size: 18px;
  font-weight: 900;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }
`;

const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

const ModalCard = styled.div`
  width: calc(100% - 40px);
  max-width: 350px;

  max-height: 80vh;
  overflow-y: auto;
  overflow-x: hidden;

  padding: 12px 16px;
  border-radius: 20px;

  background: #111827;
  border: 1px solid rgba(255, 255, 255, 0.14);
  color: #e5e7eb;

  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.35) transparent;

  &::-webkit-scrollbar {
    width: 7px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.3);
    border-radius: 999px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.45);
  }
`;

const ModalTitle = styled.h3`
  margin: 0 0 7px;
  color: #fff;
  font-size: 16px;
`;

const MetricItem = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #e5e7eb;
  cursor: pointer;

  input {
    margin: 0;
  }
`;

const SettingRow = styled.label`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2px 0;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
`;

const CloseModalButton = styled.button`
  width: 100%;
  border: none;
  border-radius: 999px;
  padding: 9px 14px;
  margin-top: 10px;
  font-size: 15px;
  font-weight: 800;
  cursor: pointer;

  position: sticky;
  bottom: 0;
  z-index: 10;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.55;
  }
`;

const MetricsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px 20px;
  margin-top: 6px;
`;

const Hero = styled.div`
  position: relative;
  height: 260px;

  margin-top: -22px;
  margin-left: -22px;
  margin-right: -22px;

  border-radius: 28px 28px 0 0;
  overflow: hidden;

  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
`;

const HeroOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.25),
    rgba(0, 0, 0, 0.65)
  );
`;

const HeroContent = styled.div`
  position: relative;
  z-index: 2;
  height: 100%;
  padding: 20px 24px;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const HeroTopRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  /*
   * Keep fixed controls in the same positions:
   * Circle logo left, settings right.
   */
  direction: ltr;
`;

const HeroBottom = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${({ rtl }) => (rtl ? "flex-end" : "flex-start")};
  text-align: ${({ rtl }) => (rtl ? "right" : "left")};
  margin-bottom: 40px;
`;

const HeroTitle = styled.h1`
  margin: 0;
  color: white;
  font-size: 42px;
  font-weight: 800;
`;

const ScoreArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;

  @media (max-width: 560px) {
    grid-column: 3;
  }
`;

const ScoreChange = styled.div`
  padding: 4px 9px;
  border-radius: 999px;

  color: #86efac;
  background: rgba(34, 197, 94, 0.15);
  border: 1px solid rgba(34, 197, 94, 0.35);

  font-size: 12px;
  font-weight: 900;
  white-space: nowrap;

  animation: scoreChangePulse 4s ease-out forwards;

  @keyframes scoreChangePulse {
    0% {
      opacity: 0;
      transform: translateY(7px) scale(0.85);
    }

    12% {
      opacity: 1;
      transform: translateY(0) scale(1.08);
    }

    25% {
      transform: scale(1);
      box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.55);
    }

    55% {
      box-shadow: 0 0 0 12px rgba(34, 197, 94, 0);
    }

    80% {
      opacity: 1;
    }

    100% {
      opacity: 0;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

const HeroSubtitle = styled.div`
  color: rgba(255, 255, 255, 0.85);
  font-size: 16px;
  margin-top: 8px;
`;

const HeroStats = styled.div`
  color: white;
  margin-top: 10px;
  font-size: 14px;
`;

const SettingColumn = styled.div`
  padding: 5px 0;
`;

const SettingLabel = styled.div`
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 3px;
`;

const ActivitySelect = styled.select`
  width: 100%;
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 14px;
  padding: 6px 10px;
  font-size: 13px;
  background: #0f172a;
  color: #e5e7eb;
  font-weight: 700;
  outline: none;
`;

const DateRangeGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-top: 10px;
`;

const DateField = styled.label`
  display: flex;
  flex-direction: column;
  gap: 5px;
  color: #cbd5e1;
  font-size: 12px;
  font-weight: 700;
`;

const DateInput = styled.input`
  width: 100%;
  box-sizing: border-box;
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 12px;
  padding: 8px 10px;
  background: #0f172a;
  color: #e5e7eb;
  font-size: 13px;
  color-scheme: dark;
  outline: none;
`;

const DateError = styled.div`
  margin-top: 7px;
  color: #fca5a5;
  font-size: 12px;
`;

const AnimatedNumber = ({ value, formatValue }) => {
  const numericValue = Number(value) || 0;

  const previousValueRef = useRef(null);
  const [displayValue, setDisplayValue] = useState(numericValue);

  useEffect(() => {
    const previousValue = previousValueRef.current;

    // First load: show the current value immediately
    if (previousValue === null) {
      previousValueRef.current = numericValue;
      setDisplayValue(numericValue);
      return;
    }

    // No change: keep the current value
    if (previousValue === numericValue) {
      setDisplayValue(numericValue);
      return;
    }

    // Refresh with changed data: start 50 below the new value
    const startValue = Math.max(0, numericValue - 50);
    const duration = 1800;
    const startTime = performance.now();

    let animationFrame;

    setDisplayValue(startValue);

    const animate = (currentTime) => {
      const progress = Math.min((currentTime - startTime) / duration, 1);
      const easedProgress = 1 - Math.pow(1 - progress, 3);

      const animatedValue =
        startValue + (numericValue - startValue) * easedProgress;

      setDisplayValue(animatedValue);

      if (progress < 1) {
        animationFrame = requestAnimationFrame(animate);
      }
    };

    previousValueRef.current = numericValue;
    animationFrame = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(animationFrame);
    };
  }, [numericValue]);

  return formatValue(displayValue);
};

function CircleLeaderboard(props) {
  //const circleId = props.match?.params?.id;
  const token = props.match?.params?.token;

  const [circleData, setCircleData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [leaderboardUnavailable, setLeaderboardUnavailable] = useState(false);
  const [metric, setMetric] = useState("steps");
  const [leaderboard, setLeaderboard] = useState([]);
  const [stepsLeaderboard, setStepsLeaderboard] = useState([]);
  const [circleNotes, setCircleNotes] = useState([]);
  const [autoRotate, setAutoRotate] = useState(true);
  const [refreshIntervalMinutes, setRefreshIntervalMinutes] = useState(2);
  const [showQR, setShowQR] = useState(true);
  const [excludeAdmin, setExcludeAdmin] = useState(true);
  const [rtlMode, setRtlMode] = useState(false);
  const [displayScale, setDisplayScale] = useState(100);
  const [showSettingsModal, setShowSettingsModal] = useState(false);
  const [selectedActivityId, setSelectedActivityId] = useState("all");
  const [notesTimeFrame, setNotesTimeFrame] = useState("30");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const previousScoresRef = useRef(new Map());
  const scoreUpdateTimerRef = useRef(null);

  const [scoreUpdates, setScoreUpdates] = useState({});

  const [visibleMetrics, setVisibleMetrics] = useState({
    steps: true,
    distance: true,
    points: true,
    checkins: true,
  });

  const [savingSettings, setSavingSettings] = useState(false);
  const [settingsError, setSettingsError] = useState("");
  const [settingsChanged, setSettingsChanged] = useState(false);
  const settingsModalOpenRef = useRef(false);

  const hasInvalidDateRange =
    notesTimeFrame === "custom" && (!fromDate || !toDate || fromDate > toDate);

  const circleId = circleData?._id;

  const previousMemberIdsRef = useRef(null);
  const joinToastTimerRef = useRef(null);

  const [joinedUserToast, setJoinedUserToast] = useState(null);

  const metricOrder = useMemo(() => {
    const items = [];

    if (circleData?.showSteps && visibleMetrics.steps) items.push("steps");

    if (visibleMetrics.distance) items.push("distance");

    if (visibleMetrics.points) items.push("points");

    if (visibleMetrics.checkins) items.push("checkins");

    return items;
  }, [circleData?.showSteps, visibleMetrics]);

  const circleActivities = useMemo(() => {
    const goals = Array.isArray(circleData?.goals) ? circleData.goals : [];

    return goals
      .map((goal) => ({
        id: String(goal.goal_id || goal._id || ""),
        title:
          goal.goalDetails?.goal_title ||
          goal.goal_title ||
          goal.title ||
          goal.name ||
          "Untitled Activity",
      }))
      .filter((goal) => goal.id);
  }, [circleData?.goals]);

  useEffect(() => {
    if (!token) {
      setLeaderboardUnavailable(true);
      setLoading(false);
      return;
    }

    loadCircle();

    const interval = setInterval(
      () => {
        loadCircle(true);
      },
      refreshIntervalMinutes * 60 * 1000,
    );

    return () => clearInterval(interval);
  }, [token, refreshIntervalMinutes]);

  const showJoinedUserToast = (member) => {
    if (!member) return;

    if (joinToastTimerRef.current) {
      clearTimeout(joinToastTimerRef.current);
    }

    const nickname = member.nickname || member.name || "New member";

    setJoinedUserToast({
      nickname,
      image: member.image
        ? member.image.startsWith("http")
          ? member.image
          : process.env.REACT_APP_IMG_FOLDER + member.image
        : null,
    });

    joinToastTimerRef.current = setTimeout(() => {
      setJoinedUserToast(null);
    }, 5000);
  };

  useEffect(() => {
    return () => {
      if (joinToastTimerRef.current) {
        clearTimeout(joinToastTimerRef.current);
      }

      if (scoreUpdateTimerRef.current) {
        clearTimeout(scoreUpdateTimerRef.current);
      }
    };
  }, []);

  const updateVisibleMetric = (key, checked) => {
    setSettingsError("");

    setVisibleMetrics((current) => {
      const next = {
        ...current,
        [key]: checked,
      };

      const hasAtLeastOneVisibleMetric =
        (circleData?.showSteps === true && next.steps) ||
        next.distance ||
        next.points ||
        next.checkins;

      if (!hasAtLeastOneVisibleMetric) {
        setSettingsError(
          circleData?.showSteps
            ? "At least one metric must remain visible."
            : "At least one metric other than Steps must remain visible.",
        );

        return current;
      }
      setSettingsChanged(true);
      return next;
    });
  };

  const normalizeLeaderboardSettings = (settings = {}) => {
    const refreshInterval = Number(settings.refreshIntervalMinutes);

    return {
      autoRotate: settings.autoRotate !== false,

      refreshIntervalMinutes: [1, 2, 5, 10, 15].includes(refreshInterval)
        ? refreshInterval
        : 2,

      showQR: settings.showQR !== false,

      excludeAdmin: settings.excludeAdmin !== false,

      rtlMode: settings.rtlMode === true,

      displayScale: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100].includes(
        Number(settings.displayScale),
      )
        ? Number(settings.displayScale)
        : 100,

      selectedActivityId: settings.selectedActivityId || "all",

      notesTimeFrame: settings.notesTimeFrame || "30",

      fromDate: settings.fromDate || "",

      toDate: settings.toDate || "",

      visibleMetrics: {
        steps: settings.visibleMetrics?.steps !== false,

        distance: settings.visibleMetrics?.distance !== false,

        points: settings.visibleMetrics?.points !== false,

        checkins: settings.visibleMetrics?.checkins !== false,
      },
    };
  };

  const applyLeaderboardSettings = (settings) => {
    const normalized = normalizeLeaderboardSettings(settings);

    setAutoRotate(normalized.autoRotate);

    setRefreshIntervalMinutes(normalized.refreshIntervalMinutes);

    setShowQR(normalized.showQR);

    setExcludeAdmin(normalized.excludeAdmin);

    setRtlMode(normalized.rtlMode);

    setDisplayScale(normalized.displayScale);

    setSelectedActivityId(normalized.selectedActivityId);

    setNotesTimeFrame(normalized.notesTimeFrame);

    setFromDate(normalized.fromDate);
    setToDate(normalized.toDate);

    setVisibleMetrics(normalized.visibleMetrics);

    return normalized;
  };

  const closeSettingsModal = () => {
    /*
     * Restore DB values and discard unsaved edits.
     */
    applyLeaderboardSettings(circleData?.leaderboardSettings);

    settingsModalOpenRef.current = false;
    setSettingsError("");
    setShowSettingsModal(false);
  };

  const openSettingsModal = () => {
    /*
     * Always begin with the latest DB values.
     */
    applyLeaderboardSettings(circleData?.leaderboardSettings);

    setSettingsError("");
    setSettingsChanged(false);
    settingsModalOpenRef.current = true;
    setShowSettingsModal(true);
  };

  useEffect(() => {
    // Wait until the circle and its settings finish loading
    if (!circleData) return;
    if (!metricOrder.length) return;

    // Keep Steps when it is available.
    // Otherwise use the first available metric.
    if (!metricOrder.includes(metric)) {
      setMetric(metricOrder[0]);
    }
  }, [circleData, metricOrder, metric]);

  useEffect(() => {
    if (!autoRotate) return;
    if (!metricOrder.length) return;

    const interval = setInterval(() => {
      setMetric((currentMetric) => {
        const currentIndex = metricOrder.indexOf(currentMetric);

        const nextIndex =
          currentIndex === -1 || currentIndex === metricOrder.length - 1
            ? 0
            : currentIndex + 1;

        return metricOrder[nextIndex];
      });
    }, 300000);

    return () => clearInterval(interval);
  }, [autoRotate, metricOrder]);

  const loadCircle = async (backgroundRefresh = false) => {
    try {
      if (!backgroundRefresh) {
        setLoading(true);
      }

      /*
       * First load the Circle and its DB settings.
       */
      const circleRes = await axios.get(
        process.env.REACT_APP_API_URL + "circles/leaderboard/public/" + token,
      );

      const circle = circleRes.data.circle;

      const baseLeaderboard = circleRes.data.leaderboard || [];

      const dbSettings = normalizeLeaderboardSettings(
        circle.leaderboardSettings || circleRes.data.leaderboardSettings,
      );

      /*
       * Keep the normalized DB settings on circleData.
       */
      circle.leaderboardSettings = dbSettings;

      /*
       * Do not overwrite modal controls during editing.
       */
      if (!settingsModalOpenRef.current) {
        applyLeaderboardSettings(dbSettings);
      }

      const activeTimeFrame = dbSettings.notesTimeFrame;

      const activeFromDate = dbSettings.fromDate;

      const activeToDate = dbSettings.toDate;

      const isCustomDateRange = activeTimeFrame === "custom";

      const hasValidCustomDateRange =
        isCustomDateRange &&
        activeFromDate &&
        activeToDate &&
        activeFromDate <= activeToDate;

      const dateRangePayload = hasValidCustomDateRange
        ? {
            fromDate: activeFromDate,
            toDate: activeToDate,
          }
        : {};

      const circleId = circle._id;

      /*
       * Detect newly joined members.
       */
      const currentMemberIds = baseLeaderboard
        .map((member) => String(member.uid || member._id || ""))
        .filter(Boolean);

      if (previousMemberIdsRef.current !== null) {
        const newMembers = baseLeaderboard.filter((member) => {
          const memberId = String(member.uid || member._id || "");

          return memberId && !previousMemberIdsRef.current.includes(memberId);
        });

        if (newMembers.length > 0) {
          showJoinedUserToast(newMembers[0]);
        }
      }

      previousMemberIdsRef.current = currentMemberIds;

      /*
       * Load steps using the DB time-frame settings.
       */
      let stepsRows = [];

      try {
        const stepsRes = await axios.post(
          process.env.REACT_APP_API_URL + "logs/steps/leaderboard",
          {
            deviceUID: "eabc2583-cd2d-4b18-bcdc-abd890f7acc3",

            numOfDays:
              activeTimeFrame === "all" || isCustomDateRange
                ? 0
                : Number(activeTimeFrame),

            ...dateRangePayload,

            limit: 200,
          },
        );

        if (stepsRes.data.success) {
          stepsRows = stepsRes.data.leaderboard || [];
        }
      } catch (stepsError) {
        console.log("Steps leaderboard load error:", stepsError);
      }

      /*
       * Load notes using the DB time-frame settings.
       */
      let notesRows = [];

      try {
        const notesRes = await axios.post(
          process.env.REACT_APP_API_URL + "notes/get-recent-notes-bycircleid",
          {
            circleId,
            deviceUID: "public",
            excludeOwn: false,
            limit: 300,

            numOfDays:
              activeTimeFrame === "all"
                ? 36500
                : isCustomDateRange
                  ? 0
                  : Number(activeTimeFrame),

            ...dateRangePayload,
          },
        );

        if (notesRes.data.success) {
          notesRows = notesRes.data.notes || [];
        }
      } catch (notesError) {
        console.log("Circle notes load error:", notesError);
      }

      setCircleData(circle);
      setLeaderboard(baseLeaderboard);
      setStepsLeaderboard(stepsRows);
      setCircleNotes(notesRows);

      setLeaderboardUnavailable(false);
    } catch (error) {
      console.log("Circle leaderboard load error:", error);

      setLeaderboardUnavailable(true);
    } finally {
      if (!backgroundRefresh) {
        setLoading(false);
      }
    }
  };

  const saveLeaderboardSettings = async () => {
    if (hasInvalidDateRange) {
      setSettingsError("Please select a valid start and end date.");

      return;
    }

    const hasVisibleMetric =
      (circleData?.showSteps === true && visibleMetrics.steps) ||
      visibleMetrics.distance ||
      visibleMetrics.points ||
      visibleMetrics.checkins;

    if (!hasVisibleMetric) {
      setSettingsError(
        circleData?.showSteps
          ? "At least one metric must remain visible."
          : "At least one metric other than Steps must remain visible.",
      );

      return;
    }

    try {
      setSavingSettings(true);
      setSettingsError("");

      const settingsPayload = {
        autoRotate,

        refreshIntervalMinutes,

        showQR,

        excludeAdmin,

        rtlMode,
        displayScale,
        selectedActivityId: selectedActivityId || "all",

        notesTimeFrame,

        fromDate: notesTimeFrame === "custom" ? fromDate : "",

        toDate: notesTimeFrame === "custom" ? toDate : "",

        visibleMetrics: {
          steps: visibleMetrics.steps,
          distance: visibleMetrics.distance,
          points: visibleMetrics.points,
          checkins: visibleMetrics.checkins,
        },
      };

      const response = await axios.patch(
        process.env.REACT_APP_API_URL +
          "circles/leaderboard/public/" +
          token +
          "/settings",
        {
          leaderboardSettings: settingsPayload,
        },
      );

      if (!response.data?.success) {
        throw new Error(
          response.data?.message || "Settings could not be saved",
        );
      }

      settingsModalOpenRef.current = false;
      setShowSettingsModal(false);
      setSettingsChanged(false);

      /*
       * Reload everything from MongoDB.
       */
      await loadCircle();
    } catch (error) {
      console.log("Save leaderboard settings error:", error);

      setSettingsError(
        error.response?.data?.message ||
          error.message ||
          "Could not save leaderboard settings.",
      );
    } finally {
      setSavingSettings(false);
    }
  };

  function getCircleStatsFromNotes(userId, notes = []) {
    let points = 0;
    let checkins = 0;
    let distance = 0;
    const imageBonusTracker = new Set();

    notes.forEach((note) => {
      if (
        selectedActivityId !== "all" &&
        String(
          note?.note_rel_goal_parent_id ||
            note?.note_rel_goal_id ||
            note?.goal_id ||
            note?.note_goal_id ||
            "",
        ) !== String(selectedActivityId)
      ) {
        return;
      }
      if (String(note?.note_type) !== "2") return;
      if (String(note?.created_uid) !== String(userId)) return;

      checkins += 1;

      const task = Array.isArray(note?.note_task) ? note.note_task[0] : null;
      const taskTotalScore = Number(task?.task_totalscore || 0);

      if (!Number.isNaN(taskTotalScore)) {
        points += Math.round(taskTotalScore * 100);
      }

      const dayKey = note?.created_date
        ? new Date(note.created_date).toISOString().slice(0, 10)
        : "unknown-day";

      const bonusKey = `${userId}_${note?.note_rel_task_id}_${dayKey}`;

      if (note?.note_image && !imageBonusTracker.has(bonusKey)) {
        points += 5;
        imageBonusTracker.add(bonusKey);
      }

      try {
        const parsed =
          typeof note?.note_value === "string"
            ? JSON.parse(note.note_value)
            : note?.note_value || {};

        const noteDistance = Number(parsed?.distance || 0);

        if (!Number.isNaN(noteDistance)) {
          distance += noteDistance;
        }
      } catch (e) {}
    });

    return {
      points,
      checkins,
      distance: Number(distance.toFixed(2)),
    };
  }

  const leaders = useMemo(() => {
    const members = leaderboard || [];

    return [...members]
      .map((member) => {
        const nickname = member.nickname || member.name || "Member";

        return {
          id: member.uid || member._id || nickname,
          nickname,
          image: member.image
            ? member.image.startsWith("http")
              ? member.image
              : process.env.REACT_APP_IMG_FOLDER + member.image
            : null,
          steps: (() => {
            const stepRow = stepsLeaderboard.find((row) => {
              const rowUserId =
                row.userId ||
                row.uid ||
                row._id ||
                row.user_id ||
                row.created_uid;

              return String(rowUserId) === String(member.uid);
            });

            return Number(
              stepRow?.steps || member.totalSteps || member.steps || 0,
            );
          })(),
          ...getCircleStatsFromNotes(member.uid, circleNotes),
        };
      })
      .map((member) => ({
        ...member,
        score:
          metric === "distance"
            ? member.distance
            : metric === "steps"
              ? member.steps
              : metric === "points"
                ? member.points
                : member.checkins,
      }))
      .filter((member) => Number(member.score) > 0)
      .sort((a, b) => b.score - a.score)
      .slice(0, 30);
  }, [leaderboard, stepsLeaderboard, circleNotes, metric, selectedActivityId]);

  useEffect(() => {
    if (!leaders.length) return;

    const nextScores = new Map(previousScoresRef.current);
    const detectedUpdates = {};

    leaders.forEach((member) => {
      const scoreKey = `${metric}:${member.id}`;
      const currentScore = Number(member.score) || 0;
      const previousScore = previousScoresRef.current.get(scoreKey);

      if (previousScore !== undefined && currentScore > previousScore) {
        detectedUpdates[member.id] = currentScore - previousScore;
      }

      nextScores.set(scoreKey, currentScore);
    });

    previousScoresRef.current = nextScores;

    if (Object.keys(detectedUpdates).length > 0) {
      setScoreUpdates(detectedUpdates);

      if (scoreUpdateTimerRef.current) {
        clearTimeout(scoreUpdateTimerRef.current);
      }

      scoreUpdateTimerRef.current = setTimeout(() => {
        setScoreUpdates({});
      }, 4000);
    }
  }, [leaders, metric]);

  const formatScore = (score) => {
    const numericScore = Number(score) || 0;

    if (metric === "distance") {
      return `${numericScore.toFixed(2)} km`;
    }

    const roundedScore = Math.round(numericScore);

    if (metric === "steps") {
      return `${roundedScore.toLocaleString()} steps`;
    }

    if (metric === "points") {
      return `${roundedScore.toLocaleString()} pts`;
    }

    return `${roundedScore.toLocaleString()} check-ins`;
  };

  const heroImage = circleData?.circle_image
    ? process.env.REACT_APP_IMG_FOLDER + circleData.circle_image
    : "/images/circle-placeholder.jpg";

  const circleLogoUrl = circleData?.circle_logo
    ? `${
        circleData.circle_logo.startsWith("http")
          ? circleData.circle_logo
          : process.env.REACT_APP_IMG_FOLDER + circleData.circle_logo
      }?v=${encodeURIComponent(circleData.updatedAt || "2")}`
    : "";

  if (leaderboardUnavailable) {
    return (
      <Page>
        <Helmet>
          <title>Circle Unavailable | Bealyo</title>
        </Helmet>

        <Card
          style={{
            minHeight: "420px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          <div>
            <Logo
              src="/logo.png"
              alt="Bealyo"
              style={{ marginBottom: "30px" }}
            />

            <div
              style={{
                fontSize: "52px",
                marginBottom: "20px",
              }}
            >
              🏆
            </div>

            <h1
              style={{
                color: "#fff",
                fontSize: "28px",
                marginBottom: "12px",
              }}
            >
              This Bealyo Circle is not available
            </h1>

            <p
              style={{
                color: "#94a3b8",
                fontSize: "16px",
                lineHeight: "1.6",
                maxWidth: "460px",
                margin: "0 auto",
              }}
            >
              This leaderboard link may have expired or been disabled by the
              Circle admin.
            </p>
          </div>
        </Card>

        <Copyright>
          © Bealyo {new Date().getFullYear()}. All rights reserved.
        </Copyright>
      </Page>
    );
  }

  const formatDisplayDate = (value) => {
    if (!value) return "";

    return new Date(`${value}T00:00:00`).toLocaleDateString();
  };

  const timeFrameLabel =
    notesTimeFrame === "1"
      ? "Current day"
      : notesTimeFrame === "7"
        ? "Last 7 days"
        : notesTimeFrame === "30"
          ? "Last 30 days"
          : notesTimeFrame === "60"
            ? "Last 60 days"
            : notesTimeFrame === "90"
              ? "Last 90 days"
              : notesTimeFrame === "custom"
                ? fromDate && toDate
                  ? `${formatDisplayDate(fromDate)} – ${formatDisplayDate(toDate)}`
                  : "Custom dates"
                : "All time";

  return (
    <Page dir={rtlMode ? "rtl" : "ltr"} rtl={rtlMode}>
      <Helmet>
        <title>Circle Leaderboard | Bealyo</title>
      </Helmet>

      <Card
        style={{
          zoom: `${displayScale}%`,
        }}
      >
        <Hero
          style={{
            backgroundImage: `url(${heroImage})`,
          }}
        >
          <HeroOverlay />

          <HeroContent>
            <HeroTopRow>
              {circleLogoUrl ? (
                <CircleLogoContainer>
                  <CircleLogo
                    src={circleLogoUrl}
                    alt={`${circleData?.name || "Circle"} logo`}
                  />
                </CircleLogoContainer>
              ) : (
                <Logo src="/logo.png" alt="Bealyo" />
              )}

              <TopRightButtons>
                <SettingsButton
                  type="button"
                  onClick={openSettingsModal}
                  title="Leaderboard settings"
                >
                  ⚙
                </SettingsButton>
              </TopRightButtons>
            </HeroTopRow>

            <HeroBottom rtl={rtlMode}>
              <HeroTitle>
                {circleData?.name ||
                  (rtlMode ? "לוח מובילים" : "Circle Leaderboard")}
              </HeroTitle>

              <HeroSubtitle>
                {rtlMode
                  ? "המשתמשים המובילים בקהילה"
                  : "Top members in this circle"}
              </HeroSubtitle>
              <HeroStats>
                {leaders.length === 0
                  ? rtlMode
                    ? "אין חברים פעילים"
                    : "No active members"
                  : leaders.length === 1
                    ? rtlMode
                      ? "חבר פעיל אחד"
                      : "1 active member"
                    : rtlMode
                      ? `${leaders.length} חברים פעילים`
                      : `${leaders.length} active members`}{" "}
                •{" "}
                {selectedActivityId === "all"
                  ? "All activities"
                  : circleActivities.find((a) => a.id === selectedActivityId)
                      ?.title || "Selected activity"}{" "}
                • {timeFrameLabel} •{" "}
                <LiveIndicator>
                  <LiveDot />
                  Live
                </LiveIndicator>
              </HeroStats>
            </HeroBottom>

            {showQR && circleId && (
              <HeroQRBlock>
                <HeroQR>
                  <QRCodeCanvas
                    value={`https://www.bealyo.com/circle/${circleId}`}
                    size={110}
                    bgColor="#ffffff"
                    fgColor="#000000"
                    level="L"
                    marginSize={1}
                  />

                  <QRText>Scan to Join</QRText>
                </HeroQR>

                <PoweredBy>
                  <PoweredByText>Powered by</PoweredByText>
                  <PoweredByLogo src="/logo.png" alt="Bealyo" />
                </PoweredBy>
              </HeroQRBlock>
            )}
          </HeroContent>
        </Hero>

        <TabsRow>
          <Tabs>
            {circleData?.showSteps && visibleMetrics.steps && (
              <Tab
                active={metric === "steps"}
                onClick={() => setMetric("steps")}
              >
                {rtlMode ? "צעדים" : "Steps"}
              </Tab>
            )}

            {visibleMetrics.distance && (
              <Tab
                active={metric === "distance"}
                onClick={() => setMetric("distance")}
              >
                {rtlMode ? "מרחק" : "Distance"}
              </Tab>
            )}

            {visibleMetrics.points && (
              <Tab
                active={metric === "points"}
                onClick={() => setMetric("points")}
              >
                {rtlMode ? "נקודות" : "Points"}
              </Tab>
            )}

            {visibleMetrics.checkins && (
              <Tab
                active={metric === "checkins"}
                onClick={() => setMetric("checkins")}
              >
                {rtlMode ? "ביצועים" : "Check-ins"}
              </Tab>
            )}
          </Tabs>
        </TabsRow>

        {loading && <Empty>Loading leaderboard...</Empty>}

        {!loading && !leaders.length && (
          <Empty>
            {metric === "steps"
              ? "The leaderboard is ready - take the first step! 👟"
              : metric === "distance"
                ? "The leaderboard is ready - be the first to go the distance! 🏃"
                : metric === "points"
                  ? "The leaderboard is ready - be the first to earn points! ⭐"
                  : "The leaderboard is ready - complete an activity to get started! 🔥"}
          </Empty>
        )}

        {!loading &&
          leaders.map((member, index) => (
            <Row
              key={`${metric}-${member.id}`}
              index={index}
              leader={index === 0}
              updated={Boolean(scoreUpdates[member.id])}
            >
              <Rank>#{index + 1}</Rank>

              <Avatar
                src={member.image || DEFAULT_AVATAR}
                alt={member.nickname || "User"}
                onError={(event) => {
                  event.currentTarget.onerror = null;
                  event.currentTarget.src = DEFAULT_AVATAR;
                }}
              />

              <div style={{ textAlign: rtlMode ? "right" : "left" }}>
                <Name>
                  {rtlMode ? `${member.nickname}@` : `@${member.nickname}`}
                </Name>

                <Meta>
                  {rtlMode
                    ? index === 0
                      ? "המוביל כרגע"
                      : "חבר בקהילה"
                    : index === 0
                      ? "Current leader"
                      : "Circle member"}
                </Meta>
              </div>

              <ScoreArea>
                <Score>
                  <AnimatedNumber
                    value={member.score}
                    formatValue={(animatedValue) => formatScore(animatedValue)}
                  />
                </Score>

                {scoreUpdates[member.id] > 0 && (
                  <ScoreChange>
                    +{formatScore(scoreUpdates[member.id])}
                  </ScoreChange>
                )}
              </ScoreArea>
            </Row>
          ))}
      </Card>

      <Copyright>
        © Bealyo {new Date().getFullYear()}. All rights reserved.
      </Copyright>

      {showSettingsModal && (
        <ModalOverlay onClick={closeSettingsModal}>
          <ModalCard onClick={(e) => e.stopPropagation()}>
            <ModalTitle>Leaderboard Settings</ModalTitle>

            <SettingRow>
              <span>Auto switch metrics every 5 minutes</span>

              <Switch
                type="checkbox"
                checked={autoRotate}
                onChange={(e) => {
                  setAutoRotate(e.target.checked);
                  setSettingsChanged(true);
                }}
              />
            </SettingRow>

            <SettingColumn>
              <SettingLabel>Refresh Data</SettingLabel>

              <ActivitySelect
                value={refreshIntervalMinutes}
                onChange={(e) => {
                  setRefreshIntervalMinutes(Number(e.target.value));
                  setSettingsChanged(true);
                }}
              >
                <option value={1}>Every minute</option>
                <option value={2}>Every 2 minutes</option>
                <option value={5}>Every 5 minutes</option>
                <option value={10}>Every 10 minutes</option>
                <option value={15}>Every 15 minutes</option>
              </ActivitySelect>
            </SettingColumn>

            <SettingRow>
              <span>Show QR code</span>

              <Switch
                type="checkbox"
                checked={showQR}
                onChange={(e) => {
                  setShowQR(e.target.checked);
                  setSettingsChanged(true);
                }}
              />
            </SettingRow>

            <SettingRow>
              <span>Exclude circle admin</span>

              <Switch
                type="checkbox"
                checked={excludeAdmin}
                onChange={(e) => {
                  setExcludeAdmin(e.target.checked);
                  setSettingsChanged(true);
                }}
              />
            </SettingRow>

            <SettingRow>
              <span>RTL layout</span>

              <Switch
                type="checkbox"
                checked={rtlMode}
                onChange={(e) => {
                  setRtlMode(e.target.checked);
                  setSettingsChanged(true);
                }}
              />
            </SettingRow>

            <SettingColumn>
              <SettingLabel>TV Display Size</SettingLabel>

              <ActivitySelect
                value={displayScale}
                onChange={(e) => {
                  setDisplayScale(Number(e.target.value));
                  setSettingsChanged(true);
                }}
              >
                <option value={100}>100%</option>
                <option value={90}>90%</option>
                <option value={80}>80%</option>
                <option value={70}>70%</option>
                <option value={60}>60%</option>
                <option value={50}>50%</option>
                <option value={40}>40%</option>
                <option value={30}>30%</option>
                <option value={20}>20%</option>
                <option value={10}>10%</option>
              </ActivitySelect>
            </SettingColumn>

            <SettingColumn>
              <SettingLabel>Activity</SettingLabel>

              <ActivitySelect
                value={selectedActivityId}
                onChange={(e) => {
                  setSelectedActivityId(e.target.value);
                  setSettingsChanged(true);
                }}
              >
                <option value="all">All activities in this circle</option>

                {circleActivities.map((activity) => (
                  <option key={activity.id} value={activity.id}>
                    {activity.title}
                  </option>
                ))}
              </ActivitySelect>
            </SettingColumn>

            <SettingColumn>
              <SettingLabel>Time Frame</SettingLabel>

              <ActivitySelect
                value={notesTimeFrame}
                onChange={(e) => {
                  setNotesTimeFrame(e.target.value);
                  setSettingsChanged(true);
                }}
              >
                <option value="1">Current day</option>
                <option value="7">Last 7 days</option>
                <option value="30">Last 30 days</option>
                <option value="60">Last 60 days</option>
                <option value="90">Last 90 days</option>
                <option value="all">All time</option>
                <option value="custom">Custom dates</option>
              </ActivitySelect>

              {notesTimeFrame === "custom" && (
                <>
                  <DateRangeGrid>
                    <DateField>
                      <span>Start date</span>

                      <DateInput
                        type="date"
                        value={fromDate}
                        max={toDate || undefined}
                        onChange={(e) => {
                          setFromDate(e.target.value);
                          setSettingsChanged(true);
                        }}
                      />
                    </DateField>

                    <DateField>
                      <span>End date</span>

                      <DateInput
                        type="date"
                        value={toDate}
                        min={fromDate || undefined}
                        onChange={(e) => {
                          setToDate(e.target.value);
                          setSettingsChanged(true);
                        }}
                      />
                    </DateField>
                  </DateRangeGrid>

                  {hasInvalidDateRange && (
                    <DateError>
                      Please select a valid start and end date.
                    </DateError>
                  )}
                </>
              )}
            </SettingColumn>

            <SettingColumn>
              <SettingLabel>Visible Metrics</SettingLabel>

              <MetricsGrid>
                <MetricItem>
                  <Switch
                    type="checkbox"
                    checked={
                      circleData?.showSteps === true && visibleMetrics.steps
                    }
                    disabled={circleData?.showSteps !== true}
                    onChange={(event) =>
                      updateVisibleMetric("steps", event.target.checked)
                    }
                  />

                  <span>
                    Steps
                    {circleData?.showSteps !== true ? " (disabled)" : ""}
                  </span>
                </MetricItem>

                <MetricItem>
                  <Switch
                    type="checkbox"
                    checked={visibleMetrics.distance}
                    onChange={(e) =>
                      updateVisibleMetric("distance", e.target.checked)
                    }
                  />
                  <span>Distance</span>
                </MetricItem>

                <MetricItem>
                  <Switch
                    type="checkbox"
                    checked={visibleMetrics.points}
                    onChange={(e) =>
                      updateVisibleMetric("points", e.target.checked)
                    }
                  />
                  <span>Points</span>
                </MetricItem>

                <MetricItem>
                  <Switch
                    type="checkbox"
                    checked={visibleMetrics.checkins}
                    onChange={(e) =>
                      updateVisibleMetric("checkins", e.target.checked)
                    }
                  />
                  <span>Check-ins</span>
                </MetricItem>
              </MetricsGrid>
            </SettingColumn>

            {/**         
            <BackButton
              type="button"
              onClick={() => props.history.push(`/circle/${circleId}`)}
            >
              ← Back to Circle
            </BackButton>
            */}
            {settingsError && <DateError>{settingsError}</DateError>}

            <CloseModalButton
              type="button"
              disabled={
                savingSettings || hasInvalidDateRange || !settingsChanged
              }
              onClick={saveLeaderboardSettings}
            >
              {savingSettings ? "Saving..." : "Save settings"}
            </CloseModalButton>
          </ModalCard>
        </ModalOverlay>
      )}

      {joinedUserToast && (
        <JoinToast>
          <JoinToastAvatar
            src={joinedUserToast.image || DEFAULT_AVATAR}
            alt={joinedUserToast.nickname || "User"}
            onError={(event) => {
              event.currentTarget.onerror = null;
              event.currentTarget.src = DEFAULT_AVATAR;
            }}
          />

          <JoinToastText>
            <JoinToastTitle>
              🎉 @{joinedUserToast.nickname} joined the circle
            </JoinToastTitle>

            <JoinToastSub>Welcome aboard 👋</JoinToastSub>
          </JoinToastText>
        </JoinToast>
      )}
    </Page>
  );
}

export default CircleLeaderboard;
